import {
  Accordion,
  Text,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import Logo from "../../../../../components/logos/tiber/Logo";
import classes from "./faq-item.module.css";

export interface faqItem {
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  question: string;
  answer: JSX.Element;
  color?: string;
}

export default function FaqItem({
  indx,
  faq,
}: {
  indx: number;
  faq: faqItem;
}) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const iconColor =
    colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.darkblue[5];

  return (
    <Accordion.Item
      key={indx}
      value={indx.toString()}
      className={classes.itemRoot}
    >
      <Accordion.Control
        icon={
          mobile ? undefined : faq.icon ? (
            <faq.icon
              style={{ width: "20px", height: "20px" }}
              htmlColor={iconColor}
            />
          ) : (
            <Logo color={iconColor} size={20} />
          )
        }
      >
        <Text
          c={colorScheme === "dark" ? theme.colors.gray[3] : "darkblue"}
          fw={500}
        >
          {faq.question}?
        </Text>
      </Accordion.Control>
      <Accordion.Panel>{faq.answer}</Accordion.Panel>
    </Accordion.Item>
  );
}
